import styled, { css } from "styled-components"
import { Link } from "react-scroll"
import Breakpoints from "../shared/breakpoints"
import TextStyles from "../shared/typography.styles"
import { T } from "../../design-system/styles/typography"

export const Container = styled.div`

  margin: 20px 0;

  @media (min-width: ${Breakpoints.lg}) {
    margin: 128px 0;
  }
`

export const Spacer = styled.div`
  grid-column: 1 / -1;
  width: 100%;
  margin-top: 72px;

  @media (min-width: ${Breakpoints.md}) {
    margin-top: 96px;
  }

  @media (min-width: ${Breakpoints.lg}) {
    margin-top: 128px;
  }
`

export const ProjectRow = styled.div`
  grid-column: 1 / -1;
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin: 0 40px;

  & > * {
    margin: 0 5vw;
  }
`

export const ImageContainer = styled.div`
  overflow: hidden;
  align-self: center;
  & > * {
    max-width: 100%;
    max-height: 100%;
  }
  ${props => props.styles}
`

export const CopyText = styled.p`
  ${T.sm.body`400`}
  padding: 32px 0 0 0;
  & > em {
    font-weight: 500;
  }

  @media (min-width: ${Breakpoints.md}) {
    ${T.md.body`400`}
  }

  @media (min-width: ${Breakpoints.lg}) {
    ${T.lg.body`400`}
    padding: 32px 0 0 0;
  }
`

export const DemoLink = styled(Link)`
  cursor: pointer;
  ${TextStyles.desktopTextStyles.LinkText}
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px 32px;
  text-decoration: none;
  text-align: center;
  box-sizing: border-box;
  background-color: var(--burnt-orange);
  color: var(--white);
  flex-grow: 1;
`

export const LinkContainer = styled.div`
  max-width: 282px;
  width: 282px;
  display: flex;
  flex-wrap: wrap;
  align-self: center;
  margin-top: 32px;

  @media (min-width: ${Breakpoints.lg}) {
    align-self: flex-start;
    margin-top: 38px;
  }
`

export const VideoProgressContainer = styled.div`
  grid-column: 2 / -2;
  align-self: center;
  width: 100%;
  display: grid;

  margin-top: 32px;

  grid-column-gap: 48px;
  grid-row-gap: 32px;

  & p {
    color: var(--slate) !important;
  }

  @media (min-width: ${Breakpoints.md}) {
    align-self: start;
    margin-top: 64px;
    grid-template-columns: 1fr 1fr 1fr;
    grid-column: 2 / -2;
  }
  @media (min-width: ${Breakpoints.lg}) {
    grid-column: 8 / -2;

    grid-template-columns: 1fr 1fr;
  }
`

/*Project Responsive Positioning */

export const featuresImageStyle = css`
  grid-column: 1 / -1;
  margin: 48px -20px 0 -20px;

  & > * {
    width: 100% !important;
    height: 100% !important;
  }

  width: 100vw;
  height: calc(100vw * 0.5625);

  @media (min-width: ${Breakpoints.md}) {
    grid-column: 2 / -2;
    margin: 0px;

    width: 75vw;
    height: calc(75vw * 0.5625);
  }
  @media (min-width: ${Breakpoints.lg}) {
    grid-column: 1 / 7;
    grid-row: 1 / 3;
    align-self: start;

    margin-top: 56px;
    width: 46.5vw;
    height: calc(46.5vw * 0.5625);
    max-width: 670px;
    max-height: 377px;
    justify-self: center;
  }
`
export const featuresBodyStyle = css`
  grid-column: 1 / -1;
  grid-row: 1;
  @media (min-width: ${Breakpoints.md}) {
    grid-column: 2 / -2;
  }

  @media (min-width: ${Breakpoints.lg}) {
    grid-column: -6 / -2;
  }
`
export const adContentImageStyle = css`
  grid-column: 1 / -1;
  height: "500px";
  @media (min-width: ${Breakpoints.md}) {
    height: "400px";
    grid-column: 4 / -4;
  }
  @media (min-width: ${Breakpoints.lg}) {
    height: "522px";
    grid-column: -6 / -2;
    grid-row: 4;
  }
`
export const adContentBodyStyle = css`
  margin-top: 48px;
  margin-bottom: 0px !important;
  grid-column: 1 / -1;
  @media (min-width: ${Breakpoints.md}) {
    grid-column: 2 / -2;
  }

  @media (min-width: ${Breakpoints.lg}) {
    grid-column: 2 / 6;
    margin-top: 0px;
  }
`
export const insightsImageStyle = css`
  grid-column: 3 / -3;

  @media (min-width: ${Breakpoints.md}) {
    grid-column: 4 / -4;
  }
  @media (min-width: ${Breakpoints.lg}) {
    grid-column: 1 / 7;
  }
`
export const insightsBodyStyle = css`
  margin-top: 48px;
  grid-column: 1 / -1;
  @media (min-width: ${Breakpoints.md}) {
    grid-column: 2 / -2;
  }
  @media (min-width: ${Breakpoints.lg}) {
    grid-column: -6 / -2;
    margin-top: 0px;
  }
`
